<template>
  <figure @click="clickFunc()" class="image-previewer">
    <img
      width="40"
      height="40"
      :src="img || require('@/assets/img/icons/empty-image.svg')"
      alt="Preview Image"
    />
    <article>
      <img
        :src="img || require('@/assets/img/icons/empty-image.svg')"
        alt="Previewed Image"
      />
    </article>
  </figure>
</template>
<script>
export default {
  name: "ImagePreviewer",
  props: {
    img: {
      type: [String, Function],
      default: require("@/assets/img/icons/empty-image.svg")
    },
    clickFunc: {
      type: Function
    }
  }
};
</script>
<style>
.image-previewer {
  position: relative;
  margin-bottom: 0;
  display: inline-block;
}

.image-previewer img {
  cursor: pointer;
  border-radius: 8px;
  max-height: 300px;
}

.image-previewer > img ~ article > img {
  z-index: 1;
  position: absolute;
  right: 0;
  top: 100%;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.5s;
}

.image-previewer > img:hover ~ article > img {
  opacity: 1;
  visibility: visible;
  z-index:12;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/ImagePreviewer.vue